import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initProfileNewsletterForm() {
    const $ProfileNewsletterFormContainer = document.querySelectorAll<HTMLFormElement>('.js-form-profile-newsletter');
    $ProfileNewsletterFormContainer.forEach($container => {
        new ProfileNewsletterForm($container);
    });
}

export class ProfileNewsletterForm {
    $container: HTMLFormElement;
    $initialFormState: Map<string, string>;
    $submitButton: HTMLButtonElement | null;
    
    constructor($container: HTMLFormElement) {
        this.$container = $container;
        this.$initialFormState = new Map();
        this.$submitButton = this.$container.querySelector<HTMLButtonElement>('button[type="submit"]');
        this.init();
    }

    init(): void {
        this.storeInitialFormState();
        this.updateSubmitButtonState();

        this.$container.addEventListener('input', () => {
            this.updateSubmitButtonState();
        });

        // Lorsqu'on submit le formulaire
        this.$container.addEventListener('submit', evt => {
            evt.preventDefault();

            if (this.hasFormChanged()) {
                this.$container.classList.add('loading');
                
                const formDataValidation = new URLSearchParams();
                formDataValidation.append('action', 'submit_profile_newsletter_form');
            
                for (const pair of new FormData(this.$container)) {
                    formDataValidation.append(pair[0], pair[1] as string);
                }

                // Soumission ajax
                postData(script_var.ajax_url, formDataValidation).then(response => {
                    if (!response.success) {
                        // TODO
                    }

                    this.$container.classList.remove('loading');
                    this.init();
                });
            }
        });
    }

    storeInitialFormState(): void {
        for (const pair of new FormData(this.$container)) {
            this.$initialFormState.set(pair[0], pair[1] as string);
        }
    }

    hasFormChanged(): boolean {
        for (const pair of new FormData(this.$container)) {
            const fieldName = pair[0];
            const fieldValue = pair[1] as string;

            if (this.$initialFormState.get(fieldName) !== fieldValue) {
                return true;
            }
        }
        return false;
    }

    updateSubmitButtonState(): void {
        if (this.$submitButton) {
            this.$submitButton.disabled = !this.hasFormChanged();
        }
    }
}
